var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-analytics-filter-and-export',{attrs:{"onDateChange":() => _vm.onDateChangeWrapper(),"onExportCSV":() => _vm.onExportCsvWrapper(),"onExportAll":() => _vm.onExportAllWrapper(),"onLangChange":() => _vm.langChangeHandler(),"allowExportData":_vm.authorizeExportCSV,"allowExportAll":_vm.authorizeExportAll}})
}
var staticRenderFns = []

export { render, staticRenderFns }